import { useMutation } from '@tanstack/react-query'
import api from 'services/api'

interface IUseCancelOrder {
  config: {
    onSuccess: (res: any) => void
  }
}

export const useCancelOrder = (params?: IUseCancelOrder) => {
  const cancelOrder = useMutation({
    mutationFn: ({ orderId }: { orderId: string }) => api.patch(`/orders-service/${orderId}/cancel`),
    onSuccess: (res: any) => params?.config?.onSuccess && params.config.onSuccess(res),
  })

  return {
    cancelOrder,
  }
}
